<div class="d-grid psic-gap-5" [ngClass]="{ 'psic-p-9': !isMobile, 'psic-p-6 psic-mb-9': isMobile }">
  <div class="d-flex justify-content-center">
        <img src="../../../../assets/images/oneInc_logo.svg" alt="Terms-and-Conditions-img" [ngStyle]="{
                        'height': isMobile ? '54px' : '82px',
                        'width': isMobile ? '140px' : '240px'
                    }" />
    </div>

    <div class="d-flex justify-content-between align-items-center">
      @if (pageDetails.productType) {
        <h5>{{ pageDetails.productType }}</h5>
      }
      <!-- TODO Commented this, once service gives value needs to display -->
      <!-- <div class="d-grid" style="justify-items: end;">
      <div class="d-flex flex-row align-items-start">
        <h2 *ngIf="!isMobile"> {{ pageDetails.totalPremium.split('.')[0] | currency:
        'USD':'symbol':'0.0-2' }} </h2>
        <h4 *ngIf="isMobile"> {{ pageDetails.totalPremium.split('.')[0] | currency:
        'USD':'symbol':'0.0-2' }} </h4>
        <p class="alt-bold" [ngStyle]="{'margin-top': isMobile ? '8px' : '16px' }">.{{
        pageDetails.totalPremium.split('.')[1] }}</p>
      </div>
      <span class="caption">per year </span>
    </div> -->
  </div>

  <div class="d-grid" [ngClass]="{ 'psic-gap-3': !isMobile, 'psic-gap-4': isMobile }">
    <div style="background: #ddd; height: 1px"></div>
    <div class="d-flex flex-row">
      <p class="alt flex-grow-1">Premium Due Today</p>
      @if (pageDetails.dueToday) {
        <div class="d-flex align-items-center">
          <p class="alt"> {{ pageDetails.dueToday | currency: 'USD':'symbol':'1.2-2' }} </p>
        </div>
      }
    </div>

    <div class="d-flex flex-row">
      <p class="alt flex-grow-1">Processing Fee *</p>
      @if (pageDetails.processingFee) {
        <div class="d-flex align-items-center">
          <p class="alt"> {{ pageDetails.processingFee | currency: 'USD':'symbol':'1.2-2' }} </p>
        </div>
      }
    </div>

    <div class="d-flex flex-row">
      <p class="alt-bold flex-grow-1">Total due today</p>
      <div class="d-flex align-items-center">
        <h6> {{ pageDetails.totalAmountDue.split('.')[0] | currency: 'USD':'symbol':'0.0-2' }} </h6>
        <span class="caption-bold" style="margin-top: 4px;"> .{{ pageDetails.totalAmountDue.split('.')[1] || '00' }}</span>
      </div>
    </div>
    <div style="background: #ddd; height: 1px"></div>
  </div>

  <div class="caption" [innerHTML]="displayStatement1"></div>

  <div class="caption" [innerHTML]="displayStatement2"></div>

  <lib-input-checkbox [(ngModel)]="checkValue" [field]="paymentAcknowledgementField"></lib-input-checkbox>

  <div class="d-none d-md-flex align-items-center justify-content-between psic-px-9">
    <lib-button [buttonText]="'Cancel'" [buttonSize]="'large'" [buttonType]="'borderless'" [libIcon]="'back'"
    [iconLeft]="true" (callback)="dialogRef.close()"></lib-button>
    <lib-button [buttonText]="'Pay'" [buttonSize]="'large'" (click)="onOk()"
    [disabled]="!checkValue" matDialogClose></lib-button>
  </div>
  <div class="mobile-footer d-flex d-md-none align-items-center justify-content-between psic-mt-4">
    <lib-button [buttonText]="'Cancel'" [buttonTheme]="'tertiary'" [buttonSize]="'large'" [buttonType]="'borderless'" [libIcon]="'back'"
    [iconLeft]="true" (callback)="dialogRef.close()"></lib-button>
    <lib-button [buttonText]="'Pay'" [buttonTheme]="'tertiary'" [buttonSize]="'large'" (click)="onOk()"
    [disabled]="!checkValue" matDialogClose></lib-button>
  </div>
</div>